export default "__VITE_ASSET__iu$8Q_tl__"